import ProductModel from '@/Modules/Product/ProductModel.js'
import axios from 'axios'

export default class ProductService {
  static list = ({ parameters, filters }) => axios
    .get(`products${ filters }`, { params: parameters, excludeLoader: true })

  static create = payload => axios.post(`products`, payload)
  static update = (productId, payload) => axios.put(`products/${ productId }`, payload)
  static delete = productId => axios.delete(`products/${ productId }`)

  static show = productId => axios.get(`products/${ productId }`)
    .then(response => new ProductModel(response.data.data))

  static getUnlinked = entityId => axios
    .get(`entity/${entityId}/products/unlinked`)

  static getMaxIndexValue = productId => axios
    .get(`products/max-index-value/${ productId || '' }`)
}
